import { Injectable } from '@angular/core';
import { environment } from '@macs-frontend/env';
import { Company } from '@macs-frontend/features/shared';
import { Store } from '@ngrx/store';
import { function as F, option as O } from 'fp-ts';
import * as mobx from 'mobx-angular';
import { Observable } from 'rxjs';
import * as fromMeta from '../../reducers/meta';
import { makeObservable } from '../utils/mobx';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class CurrentCompanyStore extends BaseStore {
  @mobx.observable
  currentCompany?: Company;

  currentCompany$: Observable<Company>;

  @mobx.computed
  get logo(): undefined | string {
    return F.pipe(
      this.currentCompany?.logo,
      O.fromNullable,
      O.map(logo => environment.images_path + logo),
      O.toUndefined,
    );
  }

  constructor(store$: Store<any>) {
    super();

    makeObservable(this);

    this.currentCompany$ = store$
      .select(fromMeta.getCurrentCompany)
      .pipe(this.takeUntilDestroy());

    this.currentCompany$.subscribe(
      mobx.action((currentCompany: Company) => {
        this.currentCompany = currentCompany;
      }),
    );
  }
}
